import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeOAuthSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        await exchangeOAuthSession(session_id);
        // Strip hash before navigating
        window.history.replaceState({}, "", window.location.pathname);
        toast.success("Welcome back.");
        navigate("/account", { replace: true });
      } catch (e) {
        toast.error("Could not complete sign-in.");
        navigate("/login", { replace: true });
      }
    })();
  }, [exchangeOAuthSession, navigate]);

  return (
    <div className="min-h-screen bg-[color:var(--sr-bg)] flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="text-center"
        data-testid="auth-callback"
      >
        <p className="label-eyebrow text-[color:var(--sr-primary)] mb-4 flex items-center justify-center gap-3">
          <span className="w-2 h-2 rounded-full bg-[color:var(--sr-accent)] animate-pulse" />
          Signing you in
        </p>
        <p className="font-serif text-4xl text-[color:var(--sr-primary)]">
          One quiet moment.
        </p>
      </motion.div>
    </div>
  );
}
